import { render, staticRenderFns } from "./VotedSongs.vue?vue&type=template&id=222e7d25"
import script from "./VotedSongs.vue?vue&type=script&lang=js"
export * from "./VotedSongs.vue?vue&type=script&lang=js"
import style0 from "./VotedSongs.vue?vue&type=style&index=0&id=222e7d25&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports